import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { mediaAPI } from '../../services/api';
import Button from '../common/Button';
import { handleApiError } from '../../utils/helpers';

const FolderFormModal = ({ folder, parentId, clientId, onClose, onSuccess }) => {
  const { isRTL, isArabic } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (folder) {
      setFormData({
        name: folder.name || '',
        description: folder.description || '',
      });
    }
  }, [folder]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!formData.name.trim()) {
      setError(isRTL ? 'اسم المجلد مطلوب' : 'Folder name is required');
      return;
    }

    setLoading(true);

    try {
      if (folder) {
        // Update existing folder
        await mediaAPI.updateFolder(folder.id, formData);
      } else {
        // Create new folder
        await mediaAPI.createFolder({
          ...formData,
          parent_id: parentId || null,
          client_id: clientId || null,
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-gray-900">
              {folder 
                ? (isRTL ? 'تعديل المجلد' : 'Edit Folder')
                : (isRTL ? 'مجلد جديد' : 'New Folder')}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
            >
              ×
            </button>
          </div>

          {/* Error */}
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg mb-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                {isRTL ? 'اسم المجلد' : 'Folder Name'} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder={isRTL ? 'مثال: صور المنتجات' : 'e.g., Product Images'}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>

            {/* Description */}
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                {isRTL ? 'الوصف (اختياري)' : 'Description (Optional)'}
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder={isRTL ? 'وصف المجلد...' : 'Folder description...'}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3 pt-4 border-t">
              <Button
                type="button"
                variant="secondary"
                onClick={onClose}
                disabled={loading}
                className="flex-1"
              >
                {isRTL ? 'إلغاء' : 'Cancel'}
              </Button>
              <Button
                type="submit"
                variant="primary"
                loading={loading}
                disabled={loading}
                className="flex-1"
              >
                {folder 
                  ? (isRTL ? 'حفظ التغييرات' : 'Save Changes')
                  : (isRTL ? 'إنشاء المجلد' : 'Create Folder')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FolderFormModal;





